<script>
  import formFieldMixin from './form-field-mixin.js'

  export default {
    mixins: [
      formFieldMixin
    ],
    props: {
      type: {
        type: String,
        default: 'text'
      },
      step: {
        type: String,
        default: '0.01'
      }
    }
  }
</script>
<template>
  <b-form-group
    :description="description"
    :label="label"
    :label-for="inputName"
    :invalid-feedback="violations"
    :labelClass="labelClasses"
  >
    <input type=hidden :autocomplete="autocomplete" value="">
    <b-input-group>
      <slot name="prepend"></slot>
      <b-form-input
        :id="inputName"
        :name="inputName"
        :value="value"
        :placeholder="placeholder"
        @input="updateField($event)"
        :state="!isInvalid"
        :readonly="isReadOnly"
        :type="type"
        :step="type === 'number' ? step : undefined"
        trim
        :autocomplete="autocomplete"
      >
      </b-form-input>
      <slot name="append"></slot>
    </b-input-group>
  </b-form-group>
</template>
